// Spec: https://drive.google.com/drive/u/1/folders/1-GTwOWT3DA6QWTXmLzcGsDa8F8TFOpJz
import { getOwaMultiplier, getOwaUnitCode, isMicrolineAdapter } from 'utils';
import { pressureScaleForMLAdapter } from 'z3k-parser/lib/owa';
export function owaMultiplier(therm_info) {
    if (isMicrolineAdapter(therm_info.serial)) {
        if (therm_info.sensor != null) {
            return pressureScaleForMLAdapter(therm_info.sensor);
        }
        switch (therm_info.pressure_scale) {
            case '5atm':
                return 1 / 16;
            case '8atm':
                return 1 / 10;
            case '12atm':
                return ((1 / 16) * 12) / 5;
            default:
                return 1;
        }
    }
    const unit_code = getOwaUnitCode(therm_info.serial);
    if (unit_code == null)
        return 1;
    return getOwaMultiplier(unit_code);
}
